import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fillEmpty'
})
export class FillEmptyPipe implements PipeTransform {
  transform(value: string | undefined): string {
    return !!value ? value : '-';
  }
}
